import React from "react";

import {
  Button,
  CardActions,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { Plus } from "react-feather";
import { TableCard } from "@hubcapp/components";
import { TestDetailsProps } from "./types";
import { TestType } from "@hubcapp/types";
import TestDetailsTable from "./components/TestDetailsTable";

const TestDetails: React.FC<TestDetailsProps> = ({
  loading = false,
  tests = [],
  editClickHandler = () => {},
  addClickHandler = () => {},
}) => (
  <TableCard loading={loading} title="Test details">
    {Boolean(
      tests?.filter(
        test => test.type === TestType.Theory || test.type === TestType.Dit1,
      ).length,
    ) && (
      <React.Fragment>
        <TestDetailsTable
          title="Theory test"
          tests={tests.filter(
            test =>
              test.type === TestType.Theory || test.type === TestType.Dit1,
          )}
          editClickHandler={editClickHandler}
          data-test="learner-tests-theory"
        />
      </React.Fragment>
    )}
    {Boolean(
      tests?.filter(
        test => test.type === TestType.Practical || test.type === TestType.Dit2,
      ).length,
    ) && (
      <React.Fragment>
        <TestDetailsTable
          title="Practical test"
          tests={tests.filter(
            test =>
              test.type === TestType.Practical || test.type === TestType.Dit2,
          )}
          editClickHandler={editClickHandler}
          data-test="learner-tests-practical"
        />
      </React.Fragment>
    )}
    {Boolean(tests?.filter(test => test.type === TestType.Dit3).length) && (
      <React.Fragment>
        <TestDetailsTable
          title="Instructional test"
          tests={tests?.filter(test => test.type === TestType.Dit3)}
          editClickHandler={editClickHandler}
          data-test="learner-tests-instructional"
        />
      </React.Fragment>
    )}
    <TableBody>
      <TableRow>
        <TableCell colSpan={3}>
          <CardActions>
            <Button
              onClick={addClickHandler}
              startIcon={<Plus size={18} />}
              data-test="learner-tests-add-button"
            >
              Add a test date
            </Button>
          </CardActions>
        </TableCell>
      </TableRow>
    </TableBody>
  </TableCard>
);

export default TestDetails;
